import { matchPath } from 'react-router';
import UAParser from 'ua-parser-js';
import * as yup from 'yup';

export const isRoot = () => {
  return window.location.hostname.split('.').length === 2;
};

export const getRootDomain = () => {
  if (isRoot()) {
    return window.location.hostname;
  }

  return window.location.hostname.split('.').splice(1).join('.');
};

export const popup = (url: string, title: string, width: number, height: number) => {
  let windowParams = `scrollbars=yes, width=${width}, height=${height}`;
  try {
    const { top } = window;
    const x = Math.round((top.outerWidth - width) / 2 + top.screenX);
    const y = Math.round((top.outerHeight - height) / 2 + top.screenY);
    windowParams += `, top=${y}, left=${x}`;
  } catch (e) {
    // We are in an iframe from a different domain and don't have access to `top` - there will be no x and y param
  }

  const newWindow = window.open(url, title, windowParams);
  if (newWindow && newWindow.focus) {
    newWindow.focus();
  }
};

export const queryString = (params: Record<string, unknown>) => {
  return Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&');
};

/**
 * Given source dimensions and maxWidth, return the scaled height and maxWidth
 * This isn't perfect because `maxHeight` is theoretically Infinity
 */
export const resizeImage = (srcWidth: number, srcHeight: number, maxWidth: number) => {
  const portraitRatio = +(srcHeight / srcWidth).toFixed(2);
  const height = Math.round(portraitRatio * maxWidth);

  return { height, width: maxWidth };
};

export const isPathMatch = (routes: string[], pathToTest: string) => {
  return routes.some(routeToTest => {
    const matchedPath = matchPath(pathToTest, { path: routeToTest, exact: true, strict: true });
    return !!matchedPath;
  });
};

export const isEven = (index: number) => index % 2 === 0;

export const validateUrl = (url: string) => yup.string().url().required().isValidSync(url);

export const validateImageContent = (file: File) => {
  const imageElement = new Image();
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    imageElement.onload = () => {
      resolve(true);
    };

    imageElement.onerror = () => {
      reject(false);
    };

    fileReader.onload = event => {
      imageElement.src = event.target.result as string;
    };

    fileReader.readAsDataURL(file);
  });
};

export const getRenderingEngine = () => {
  const parser = new UAParser();
  return parser.getEngine().name;
};
